export const cleanCourtName = (name: string): string => {
  if (!name) return name;
  return name
    .replace("Sąd Apelacyjny", "SA")
    .replace("Sąd Rejonowy", "SR")
    .trim();
};
